/*
This is the container for the component.
This "connects" the redux and react layers by translating the state of the page into props for the component.
It also wires up the actions so the component can emit them.
*/
import {
  DynamicSelectComponent,
  DynamicSelectProps
} from '@common/components/dynamic-select/_components/dynamic-select.component';
import { connect, Dispatch } from 'react-redux';
import { AppState } from '../../../..';
import { DynamicSelectIdentifier } from '@common/components/dynamic-select/dynamic-select-types';
import {
  dynamicSelectLoadOptions,
  clearOptions,
  DynamicSelectSuccessAction,
  DynamicSelectFailureAction,
  DynamicSelectActionType
} from '@common/components/dynamic-select/dynamic-select.actions';
import { OptionsViewModel } from '../../../../_models/common.models';

interface ParentProps {
  readonly name: string;
  readonly value: string;
  readonly identifier: DynamicSelectIdentifier;
  readonly searchId?: number;
  readonly stateAbbreviation?: string;
  readonly filter?: { prop: string; value: string };
  readonly filterOut?: { prop: string; values: string[] };
  readonly disabled?: boolean;
  readonly onBlur: () => void;
  readonly onChange: () => void;
  readonly onFocus: () => void;
  readonly onKeyPress: () => void;
  readonly whenLoaded: (data: OptionsViewModel[]) => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(newState: AppState, ownProps: ParentProps): Partial<DynamicSelectProps> {
  return {
    ...ownProps,
    errorMessage: newState.dynamicSelect.errors[ownProps.identifier],
    options: newState.dynamicSelect.options[ownProps.identifier] || [],
    filter: ownProps.filter,
    filterOut: ownProps.filterOut
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: ParentProps): Partial<DynamicSelectProps> {
  return {
    loadOptions: () => {
      dispatch(dynamicSelectLoadOptions(ownProps.identifier, ownProps.searchId, ownProps.stateAbbreviation)).then(
        (action: DynamicSelectSuccessAction | DynamicSelectFailureAction) => {
          if (!ownProps.whenLoaded || !action || action.type !== DynamicSelectActionType.LoadOptionsSuccess) {
            return;
          }
          ownProps.whenLoaded((action as DynamicSelectSuccessAction).options);
        }
      );
    },
    clearOptions: () => {
      dispatch(clearOptions());
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const DynamicSelect = connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicSelectComponent);



// WEBPACK FOOTER //
// ./src/common/components/dynamic-select/_components/dynamic-select.container.tsx